import { BrowserModule } from "@angular/platform-browser";
import { APP_INITIALIZER, NgModule, isDevMode } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { Interceptor } from "./interceptor/interceptor.interceptor";
import {
  provideCacheableAnimationLoader,
  provideLottieOptions,
} from "ngx-lottie";
import player from "lottie-web";
import { ToastrModule } from "ngx-toastr";
import { provideNgxStripe } from "ngx-stripe";
import { provideScReCaptchaSettings } from "@semantic-components/re-captcha";
import { environment } from "../environments/environment";
import { MaintenanceService } from "./services/maintenance.service";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
  ],
  exports: [],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    {
      // Resolve maintenance-mode status before the app boots so the
      // maintenance screen (if on) covers everything, including login.
      provide: APP_INITIALIZER,
      useFactory: (maintenance: MaintenanceService) => () => maintenance.load(),
      deps: [MaintenanceService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
    provideLottieOptions({ player: () => player }),
    provideCacheableAnimationLoader(),
    provideNgxStripe(),
    provideScReCaptchaSettings({ v3SiteKey: environment.recaptchaSiteKey || 'placeholder' }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
